var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { transient, autoinject } from "aurelia-framework";
import { BaseResults } from "../../templates/base-results";
import { Router } from "aurelia-router";
import { ClientLotteryClientService } from "../../../../services/modules/client/client-lottery-client-service";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { I18N } from "aurelia-i18n";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { ClientHotLotteriesClientService } from "../../../../services/modules/client/client-hot-lotteries-client.service";
import { NotificationClientService } from "../../../../services/basics/notification-client.service";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { BrandClientService, TemplateType } from "../../../../services/modules/brand-client.service";
import { LookupValueQuery, LookupValueRequest } from "../../../../models/lookups/lookup.models";
import { WidgetNames } from "../../../../models/modules/lotteryplatofrm.models";
import { ConfigClientService } from "../../../../services/modules/client-config.service";
var ResultsWidget1 = /** @class */ (function (_super) {
    __extends(ResultsWidget1, _super);
    function ResultsWidget1(router, lotteryClientService, lookupClientService, i18N, tokenClient, hotLotteryClientService, notificationClientService, dialogClientService, brandClientService, configClientService) {
        var _this = _super.call(this, router, lotteryClientService, lookupClientService, i18N, hotLotteryClientService, tokenClient, notificationClientService, dialogClientService) || this;
        _this.brandClientService = brandClientService;
        _this.configClientService = configClientService;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.lotteryWidgets;
        lookupClientService.getLookup(request).then(function (x) {
            _this.currentWidgetId = x.values.filter(function (a) { return a.additionalData.internalName == WidgetNames.ResultsWidget1; })[0].id;
        });
        return _this;
    }
    ResultsWidget1.prototype.attached = function () {
        return __awaiter(this, void 0, void 0, function () {
            var assests;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.attached.call(this);
                        return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Assets)];
                    case 1:
                        assests = _a.sent();
                        this.buttonsRounded = assests[TemplateType.Assets][TemplateType.Template]["buttons"]["rounded"];
                        return [2 /*return*/];
                }
            });
        });
    };
    ResultsWidget1.prototype.isWidget = function () {
        return true;
    };
    ResultsWidget1.prototype.record = function (link) {
        this.brandClientService.recordAffiliateLink({
            referer: document.referrer,
            redirectedTo: link,
            lotteryWidgetId: this.currentWidgetId
        });
        return true;
    };
    ResultsWidget1.prototype.filterResults = function (x) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.clientLotteryClientService.getResultWidgetFeaturedKeys().then(function (featured) {
                var result = featured.map(function (a) {
                    var lottery = x.filter(function (b) { return _this.getLotteryKeyById(b.lotteryId) == a.key; })[0];
                    if (lottery) {
                        lottery.translatedLotteryName = a.text[_this.tokenClient.lang] ? a.text[_this.tokenClient.lang]["lottery-name"] : null;
                        if (!lottery.translatedLotteryName && a.text["en"])
                            lottery.translatedLotteryName = a.text["en"]["lottery-name"];
                        lottery.translatedNavigationUrl = a.text[_this.tokenClient.lang] ? a.text[_this.tokenClient.lang]["navigation-url"] : null;
                        if (!lottery.translatedNavigationUrl && a.text["en"])
                            lottery.translatedNavigationUrl = a.text["en"]["navigation-url"];
                        lottery.translatedLogo = a.image[_this.tokenClient.lang] ? a.image[_this.tokenClient.lang]["logo"].replace("/attachments/", _this.tokenClient.storageUri + "attachments/") : null;
                        if (!lottery.translatedLogo && a.image["en"]) {
                            var value = a.image["en"]["logo"];
                            lottery.translatedLogo = value.replace("/attachments/", _this.tokenClient.storageUri + "attachments/");
                        }
                    }
                    return lottery;
                });
                resolve(result);
            });
        });
    };
    ResultsWidget1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router, ClientLotteryClientService, LookupClientService, I18N, TokenClient,
            ClientHotLotteriesClientService, NotificationClientService, DialogClientService,
            BrandClientService, ConfigClientService])
    ], ResultsWidget1);
    return ResultsWidget1;
}(BaseResults));
export { ResultsWidget1 };
